"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVerifiableCredential = void 0;
function parseVerifiableCredential(schema, payload) {
    if (!payload.credentialSubject)
        throw new Error('Invalid credential');
    var credentialSubject = payload.credentialSubject;
    switch (schema) {
        case 'Email': {
            if (!credentialSubject.emailAddress)
                throw new Error('Invalid Email credential');
            return {
                'Email': {
                    text: credentialSubject.emailAddress,
                    prefix: {
                        en: 'Email address'
                    }
                }
            };
        }
        case 'Phone': {
            if (!credentialSubject.phoneNumber)
                throw new Error('Invalid Phone credential');
            return {
                'Phone': {
                    text: credentialSubject.phoneNumber,
                    prefix: {
                        en: 'Phone number'
                    }
                }
            };
        }
        default: throw new Error('Invalid schema');
    }
}
exports.parseVerifiableCredential = parseVerifiableCredential;
